import { Card, CardContent, CardHeader, Container, Grid, styled, Typography } from '@material-ui/core'
import { FC, useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import pendingStatus from '../../../../constants/pendingStatus'
import useTranslate from '../../../../i18n/useTranslate'
import { RoutePath } from '../../../../router/routesConfig'
import useWebService from '../../../../services/web/useWebService'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../utilities/date'
import { decryptionAES } from '../../../../utilities/encryption'
import { ButtonClose } from '../../project/page/pageAction'

const CustomHeader = styled(CardHeader)({
    borderBottom: '1px solid #DCDCDC',
})

const CustomUnderlineGrid = styled(Grid)({
    borderBottom: '1px solid #DCDCDC',
})

const PendingHistory: FC<{}> = () => {
    const translate = useTranslate()
    const webServiceHook = useWebService()
    const history = useHistory()
    const matchPath = useRouteMatch<{ projectData: string }>(RoutePath.projectPendingHistory)
    const encryptedProjectData = matchPath ? matchPath.params.projectData : null
    const projectData = encryptedProjectData ? JSON.parse(decryptionAES(encryptedProjectData)) : null
    const [historyInfo, setHistoryInfo] = useState<any[]>([])

    const getPendingHistory = async () => {
        /** Call service */
        const response = await webServiceHook.getHistoryPendingAndResume(Number(projectData?.submittedID))
        if (response?.result && response?.status === 1) {
            setHistoryInfo(
                response.result.map((data: any) => ({
                    th: {
                        statusName: data.status_name_th,
                        updatedDate: data.updated_date ? convertDateToFormatTH(data.updated_date) : '-',
                    },
                    en: {
                        statusName: data.status_name_en,
                        updatedDate: data.updated_date ? convertDateToFormatEN(data.updated_date) : '-',
                    },
                    remark: data.remarks,
                    statusColor: data.status_id === pendingStatus.pending ? '#000000' : '#379956',
                    rowNo: data.row_no ?? '-',
                })),
            )
        }
    }

    const handleClose = () => {
        history.push(RoutePath.manageProject)
    }

    useEffect(() => {
        getPendingHistory()
    }, [])

    return (
        <Container maxWidth="lg">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card>
                        <CustomHeader
                            title={<Typography variant="h5">{translate.get('LABEL.PENDING_HISTORY')}</Typography>}
                        />
                        <CardContent style={{ padding: '24px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={true}>
                                    <Typography variant="body2">
                                        {translate.get('LABEL.RESEARCHER_FL_NAME')} :{' '}
                                        {projectData[translate.languageStore.currentLanguage].researcherName ?? '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={5} xl={4}>
                                    <Typography variant="body2">
                                        {translate.get('LABEL.PROJECT_TYPE')} :{' '}
                                        {projectData[translate.languageStore.currentLanguage].submitTypeName ?? '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        {translate.get('LABEL.PROJECT_NAME')} :{' '}
                                        {projectData[translate.languageStore.currentLanguage].projectName ?? '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                            {historyInfo.map((data, index) => (
                                <Grid container key={data.rowNo !== '-' ? data.rowNo : index} spacing={2}>
                                    <CustomUnderlineGrid item xs={12}>
                                        &nbsp;
                                    </CustomUnderlineGrid>
                                    <Grid item xs={12}>
                                        <pre />
                                        <Typography variant="h5">
                                            {translate.get('LABEL.RESULT_TIMES', [data.rowNo])}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={6}>
                                        <Typography variant="body2">
                                            {translate.get('LABEL.STATUS')} :{' '}
                                            <span style={{ color: data.statusColor, fontWeight: 'bolder' }}>
                                                {data[translate.languageStore.currentLanguage].statusName ?? '-'}
                                            </span>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={6}>
                                        <Typography variant="body2">
                                            {translate.get('LABEL.CHANGED_DATE')} :{' '}
                                            {data[translate.languageStore.currentLanguage].updatedDate ?? '-'}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2">
                                            {translate.get('LABEL.REASON')} : {data.remark ?? '-'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            ))}
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Grid container justify="flex-end">
                        <ButtonClose onClickClose={handleClose}></ButtonClose>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}

export default PendingHistory
